<template>
    <div>
        <section>
            <div class="flex-row section-container flex-justify-center">
                <div class="flex-column flex-item-center">
                    <h1>Our Heroes!</h1>
                    <div class="flex-row flex-justify-center btn-container">
                        <router-link class="btn btn-outline-default" as="button" :to="{ name: 'AmadorHeroProfile'}">Amador</router-link>
                        <router-link class="btn btn-outline-default" as="button" :to="{ name: 'KynHeroProfile'}">Kyn</router-link>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="flex-row section-container heroPose-container flex-justify-center">
                <img class="" :src="getImgUrl(heroName + 'Pose')" />
            </div>
        </section>
        <transition name="fade" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
        </transition>
        <section class="flex-row">
            <div class="flex-column section-container">
                <h2 class="section-title">Gallery</h2>
                <div class="flex flex-column">
                    <div class="flex flex-row btn-container flex-justify-center">
                        <template v-for="filter in galleryFilters">
                            <button 
                                class="btn btn-outline-default"
                                :class="(activeGalFilter == filter) ? 'active' : ''"
                                @click="updateActiveGalFilter(filter)">
                                    {{ filter }}
                            </button>
                        </template>
                    </div>
                </div>
                <div class="flex-row flex-1 flex-justify-center image-gallery">
                    <template v-for="imgInfo in filteredGallery">
                        <img :src="imgInfo.thumbnail" @click="openGallery(imgInfo.original)" :disabled="toggleLightBox">
                    </template>
                </div>
            </div>
        </section>
        <FsLightbox
            ref="lightbox"
            :toggler="toggleLightBox"
            :sources="lightBoxSources">
        </FsLightbox>
    </div>
</template>
<script>
import { SvgIconContainer } from "@/components";
import FsLightbox from "fslightbox-vue/v3";
import galleryMixins from "../utilities/galleryMixins";

export default {
  components: {
    'svg-icon-container': SvgIconContainer,
    FsLightbox,
  },
  mixins: [galleryMixins],
  data() {
    return {

    };
  },
  created () {
    
  },
  mounted() {
    this.getMediaImages();
  },
  filters: {
    
  },
  computed: {
    filteredGallery() {
        let tempGal = this.imageGallery;
        if (this.activeGalFilter == "All") {
            tempGal = tempGal.filter((item) => {
                return item.name.includes("@" + this.$route.meta.hero);
            })
        } else {
            tempGal = tempGal.filter((item) => {
                return item.name.includes("@" + this.$route.meta.hero) && item.name.includes("+" + this.activeGalFilter);
            })
        }

        return tempGal;
    },
    heroName(){
        return this.$route.meta.hero;
    }
  },
  methods: {
    getImgUrl(picName) {
        var images = require.context('../assets/img/', false, /\.png$/)
        return images('./' + picName + ".png")
    },
  }
};</script>
<style lang="scss">
</style>
